<h2>{{groupName()}}  {{indexCurrentPhase()}}/4</h2>
Groupe de {{saveAuthor()}}
@for (member of members(); track member) {
  <span>
    {{member.name}} {{$last ? '' : ', '}}
  </span>
}
<a [routerLink]="['/iackathon-groups', save().id]">Suivre</a>
<button>Livrable -- TODO </button>